import { UserData } from 'components/pages/PeopleManagement/types/orgCanvas.type';
import {
  generateRandomAvatarUrl,
  generateRandomName,
  generateRandomRole,
  generateRandomOu,
} from './common.mock';

function createUser(id: string, parentId: string | null): UserData {
  const roleName = generateRandomRole();
  const ouName = generateRandomOu();
  return {
    id,
    image: generateRandomAvatarUrl('lernit'),
    name: generateRandomName(),
    roleId: roleName,
    roleName,
    ouId: ouName,
    ouName,
    parentId,
    directSubordinatesCount: 0,
    directSubordinatesIds: [],
    indirectSubordinatesCount: 0,
  };
}

/**
 * Generates a realistic org tree.
 * Each level gets a random number of children between minChildren and maxChildren.
 * Returns a flat array with proper parentId / directSubordinatesIds / directSubordinatesCount.
 */
export function createOrgTree(
  depth: number = 4,
  minChildren: number = 2,
  maxChildren: number = 5,
): UserData[] {
  const users: UserData[] = [];
  let counter = 0;

  const root = createUser(`user-${counter++}`, null);
  users.push(root);

  const buildLevel = (parent: UserData, currentDepth: number) => {
    if (currentDepth >= depth) return;

    const childCount =
      minChildren + Math.floor(Math.random() * (maxChildren - minChildren + 1));

    for (let i = 0; i < childCount; i++) {
      const child = createUser(`user-${counter++}`, parent.id);
      users.push(child);
      parent.directSubordinatesIds.push(child.id);
      parent.directSubordinatesCount++;

      buildLevel(child, currentDepth + 1);
    }
  };

  buildLevel(root, 0);

  return users;
}